/**
 * GoDEX DT2 label printer configuration (38 × 12 mm media).
 * Tune dot positions in LABEL_LAYOUT after physical calibration.
 */

export const LABEL_PRINTER_STORAGE_KEY = 'materiah_label_printer_name';

/** Physical label media — adjust after workstation calibration. */
export const LABEL_MEDIA = {
  widthMm: 38,
  heightMm: 12,
  dpi: 203,
  gapMm: 2,
};

/**
 * When true, qzSecurity fetches certificate/signature from backend /printing/qz-*.
 * Production: `.env.production` sets REACT_APP_QZ_SIGNING_ENABLED=true (npm run build).
 * Dev default: false unless overridden in `.env.local`.
 */
export const QZ_SIGNING_ENABLED =
  process.env.REACT_APP_QZ_SIGNING_ENABLED === 'true';

/** Substrings used to auto-suggest a GoDEX queue name from QZ printer list. */
export const GODEX_PRINTER_HINTS = ['godex', 'dt2', 'materiah'];

/**
 * EZPL dot positions for 38×12 mm @ 203 dpi (~304×96 dots).
 * Calibrate on hardware before production use.
 */
export const LABEL_LAYOUT = {
  qrX: 8,
  qrY: 8,
  qrMul: 3,
  textX: 100,
  line1Y: 72,
  line2Y: 52,
  line3Y: 32,
  productMaxLen: 22,
  metaMaxLen: 28,
};

/**
 * @param {number} mm
 * @param {number} [dpi=LABEL_MEDIA.dpi]
 * @returns {number}
 */
export const mmToDots = (mm, dpi = LABEL_MEDIA.dpi) =>
  Math.round((mm / 25.4) * dpi);

/**
 * @returns {{ widthDots: number, heightDots: number }}
 */
export const getLabelDotDimensions = () => ({
  widthDots: mmToDots(LABEL_MEDIA.widthMm),
  heightDots: mmToDots(LABEL_MEDIA.heightMm),
});
